/**
 * Mobile compatibility utilities
 * This file contains utilities to improve the app experience on mobile wallet browsers
 */

// Detect if we're on a mobile device
export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// Detect if we're in a wallet browser
export const isWalletBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return (
    userAgent.includes('trust') || 
    userAgent.includes('metamask') || 
    userAgent.includes('coinbase') || 
    userAgent.includes('rainbow') ||
    userAgent.includes('tokenpocket') ||
    userAgent.includes('imtoken') ||
    userAgent.includes('status') ||
    userAgent.includes('safepal') ||
    userAgent.includes('bitkeep') ||
    userAgent.includes('mathwallet') ||
    userAgent.includes('opera') && userAgent.includes('crypto')
  );
};

/**
 * Fix common issues with mobile wallet browsers
 * Simplified version that only adds minimal fixes
 */
export const applyMobileWalletFixes = (): void => {
  if (!isMobile) return;
  
  console.log('Applying minimal mobile wallet browser fixes');
  
  // Only add the wallet-browser class for detection purposes
  if (isWalletBrowser()) {
    document.body.classList.add('wallet-browser');
  }
};

/**
 * Clean up page transitions for mobile wallet browsers
 * Simplified version with minimal intervention
 */
export const cleanPageTransition = (): void => {
  // Only scroll to top on page transitions
  window.scrollTo(0, 0);
};

/**
 * Enhance React Router Link components for better mobile wallet browser compatibility
 * Simplified version that just returns the original onClick handler
 */
export const enhanceLinkForWalletBrowser = (onClick?: (e: React.MouseEvent) => void) => {
  return onClick;
};

/**
 * Fix for React Router's useNavigate hook
 * Simplified version that just calls the navigate function
 */
export const safeNavigate = (navigate: (to: string) => void, to: string): void => {
  navigate(to);
};
